export enum NutritionLabelDownloadFileFormat {
  Pdf,
  jpeg
}